import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';

import FooterNav from './FooterNav';

// Footer Menu
const leftMenu = [
    {
        label: 'Home',
        link: '',
        isRouter: true
    },
    {
        label: 'Works',
        link: 'works',
        isRouter: true
    },
    {
        label: 'About',
        link: 'about',
        isRouter: true
    },
    {
        label: 'Blog',
        link: 'blog',
        isRouter: true
    },
    {
        label: 'Start a Project',
        link: 'start-a-project',
        isRouter: true
    },
    {
        label: 'Visit Hubton Studio',
        link: 'visit-hubton-studio',
        isRouter: true
    },
    {
        label: 'Join Our Team',
        link: 'join-our-team',
        isRouter: true
    }
];

const socialMenu = [
    {
        label: 'Instagram',
        link: 'https://instagram.com/hubton_id',
        isRouter: false
    },
    {
        label: 'Facebook',
        link: 'https://facebook.com/hubton',
        isRouter: false
    },
];


/**
 * Footer Class
 */
class Footer extends Component {
    render() {
        return (
            <footer className="footer-section">
                <Grid>
                    <Row>
                        <Col xs={12} md={4} lg={4} className="footer-section__item">
                            <FooterNav menu={leftMenu} />
                        </Col>

                        <Col xs={12} md={4} lg={4} className="footer-section__item">
                            <FooterNav menu={socialMenu} />
                        </Col>

                        <Col xs={12} md={4} lg={4} className="footer-section__item">
                            <div className="footer-section__text">
                                <p>Hubton Head Office —<br/>
                                Jalan Sabar 8<br/>
                                Bandung, Indonesia 40161<br/>
                                info@hubton.com</p>
                            </div>
                        </Col>

                        <Col xs={12} className="footer-section__item">
                            <div className="footer-section__text copyrights">
                                <p>&copy; 2018 Hubton Indonesia. All rights reserved.<br/>
                                Hubton is a CV company. Terms of use. Privacy policy.</p>
                            </div>
                        </Col>
                    </Row>
                </Grid>
            </footer>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer/index.js